module.exports = __webpack_public_path__ + "img/bound-icon.f3eecfaa.svg";